function themeColor(theme) {
  return function (color, shade) {
    var primaryFallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var primaryShades = theme.colors[theme.primaryColor];
    return color in theme.colors ? theme.colors[color][shade] : primaryFallback ? primaryShades[shade] : color;
  };
}

export { themeColor };